const NON_BENEFIT_NARRATIONS = ['SUM INSURED', 'SUMINSURED'];

function normalizeNarration(value) {
  return String(value || '').trim().toUpperCase();
}

function isHiddenChargedBenefit(benefit) {
  const narration = normalizeNarration(benefit?.narration);
  if (!narration) return true;
  if (NON_BENEFIT_NARRATIONS.some((term) => narration === term || narration.includes(term))) {
    return true;
  }
  const amount = Number(benefit?.chargedAmount);
  return Number.isNaN(amount) || amount <= 0;
}

function riskScore(risk) {
  const sum = Number(risk?.suminsured) || 0;
  const cover = normalizeNarration(risk?.covertype);
  const comprehensiveBonus = cover.includes('COMPREHENSIVE') ? 1000000000 : 0;
  return sum + comprehensiveBonus;
}

export function displayMotorPurchasedBenefits(chargedBenefits = []) {
  const seen = new Set();
  return (chargedBenefits || [])
    .filter((benefit) => !isHiddenChargedBenefit(benefit))
    .filter((benefit) => {
      const key = benefit.sectCode || normalizeNarration(benefit.narration);
      if (seen.has(key)) return false;
      seen.add(key);
      return true;
    });
}

export function displayMotorFreeBenefits(benefits = []) {
  const seen = new Set();
  return (benefits || [])
    .filter((benefit) => benefit?.apaNarration && benefit?.value)
    .filter((benefit) => {
      const key = benefit.code || normalizeNarration(benefit.apaNarration);
      if (seen.has(key)) return false;
      seen.add(key);
      return true;
    });
}

export function displayMotorRisks(policy) {
  const risks = policy?.risks;
  if (!Array.isArray(risks) || risks.length === 0) return [];

  const byReg = new Map();
  risks.forEach((risk) => {
    const reg = String(risk?.regno || '').toUpperCase();
    const key = reg || `risk-${byReg.size}`;
    const existing = byReg.get(key);
    if (!existing || riskScore(risk) > riskScore(existing)) {
      byReg.set(key, risk);
    }
  });

  return [...byReg.values()];
}

export function resolveMotorSumInsured(policy, risk) {
  const fromRisk = Number(risk?.suminsured);
  if (fromRisk > 0) return fromRisk;
  const fromPolicy = Number(policy?.sumInsured);
  if (fromPolicy > 0) return fromPolicy;
  return 0;
}

export function resolveMotorRiskPremium(policy, risk) {
  const fromRisk = Number(risk?.riskPremium);
  if (fromRisk > 0) return fromRisk;
  return Number(policy?.premium) || Number(policy?.totalPremium) || 0;
}

export function normalizeMotorPolicyNoForDocs(policyNo) {
  if (!policyNo) return '';
  // DocuWare expects the GIS policy number unchanged (slashes, dashes, or plain).
  return String(policyNo).trim();
}
